import type { FullRecord } from "@shared/types";
import { dSt, fmtF, todayISO } from "../util";

interface Props {
  records: FullRecord[];
  onOpen: (id: number) => void;
  onReativate: (id: number) => void;
}

export function ReactivationPanel({ records, onOpen, onReativate }: Props) {
  const today = todayISO();
  const reativ = records.filter(d => d.status === "perdido" && d.reativ_data && d.reativ_data <= today);
  if (!reativ.length) return null;

  return (
    <div className="rsec">
      <div className="rsec-hdr">
        <div className="rsec-title">
          <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 .49-3.51" /></svg>
          Clientes para reativar
        </div>
        <span style={{ fontSize: 12, color: "var(--tx2)" }}>
          {reativ.length} cliente{reativ.length > 1 ? "s" : ""} aguardando reativação
        </span>
      </div>
      <div className="rcards">
        {reativ.map((d) => {
          const due = dSt(d.reativ_data!);
          const hoje = due === "late" || due === "today";
          return (
            <div key={d.id} className={"rcard" + (hoje ? " hoje" : "")}>
              <div className="rc-cli">{d.cliente}</div>
              <div className="rc-ramo">{d.ramo}{d.resp ? " · " + d.resp : ""}</div>
              {d.motivo_perda && (
                <div className="rc-motivo">
                  <span>Por que não fechou</span>
                  {d.motivo_perda}{d.motivo_det ? " — " + d.motivo_det : ""}
                </div>
              )}
              <div className="rc-dt">
                <svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                Desde {fmtF(d.reativ_data)}
              </div>
              <div className="rc-btns">
                <button className="rc-btn" onClick={() => onOpen(d.id)}>Ver ficha</button>
                <button className="rc-btn p" onClick={() => onReativate(d.id)}>Reativar agora</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
